"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_filepond_1 = require("react-filepond");

var filepond_plugin_image_exif_orientation_1 = __importDefault(require("filepond-plugin-image-exif-orientation"));

var filepond_plugin_image_preview_1 = __importDefault(require("filepond-plugin-image-preview"));

react_filepond_1.registerPlugin(filepond_plugin_image_exif_orientation_1.default, filepond_plugin_image_preview_1.default);

exports.default = function (props) {
  var url = props.url;

  var _react_1$useState = react_1.useState(null),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  var handleUpdateFiles = function handleUpdateFiles(fileItems) {
    setState(function (prevState) {
      return Object.assign(Object.assign({}, prevState), {
        files: fileItems.map(function (fileItem) {
          return fileItem.file;
        })
      });
    });
  };

  return react_1.default.createElement(react_filepond_1.FilePond, {
    files: state,
    allowMultiple: false,
    maxFiles: 3,
    server: url,
    onupdatefiles: handleUpdateFiles
  });
};